import Box from '@mui/material/Box';
import Container from '@mui/material/Container';

import Inventory from '@/assets/sidebar/inventory';
import SectionTitle from '@/components/SectionTitle/SectionTitle';
import usePageTitle from '@/hooks/usePageTitle';
import ButtonPanel from '@/sections/Fulfill/Inventory/ButtonPanel/ButtonPanel';
import Stats from '@/sections/Fulfill/Inventory/Stats/Stats';
import InventoryTable from '@/sections/Fulfill/Inventory/Table/InventoryTable';
import useInventoryPage from '@/sections/Fulfill/Inventory/useInventoryPage';

const InventoryPage = () => {
  usePageTitle('Fulfill99 - Inventario');

  const hook = useInventoryPage();

  return (
    <Container maxWidth="xxl">
      <SectionTitle title="Inventario" mt={5}>
        <Inventory fontSize="large" />
      </SectionTitle>
      <Box display="flex" flexDirection="column" gap="2rem">
        <Stats activeSkuCount={hook.activeSkuCount} />
        <ButtonPanel products={hook.productsSelected} onProductsUpdated={hook.refreshInventory} />
        <InventoryTable
          handleProductsSelected={hook.handleProductsSelected}
          onInventoryUpdated={hook.handleInventoryUpdated}
          onActiveSkuCountChange={hook.handleActiveSkuCount}
        />
      </Box>
    </Container>
  );
};

export default InventoryPage;
